import axios from "axios";
import { URL } from "./url"

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    post: (url,payload) => {
        return axios.post(URL + url,payload);
    },
}